// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3F_D9","inputWrap":"styles_inputWrap__3rRmP","input":"styles_input__1KsG6"};